import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import { makeStyles } from "@material-ui/core/styles";
import { TablePagination } from "@material-ui/core";
import { Modal, Button } from "react-bootstrap";
import propTypes from "prop-types";
import { connect } from "react-redux";
import { getUserBooks } from "../../actions/userBooks";
import axios from "axios";
import { CircularProgress } from "@material-ui/core";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import BookReview from "@material-ui/icons/LinkTwoTone";
import Eye from "@material-ui/icons/Visibility";
import DateConverter from "DateConverter/dateconverter";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';

const crypto = require("crypto");
const keys = require("../../config/key");
const algorithm = "aes-128-cbc";
const key = keys.cryptoKey;
const iv = keys.IV;

function decrypt(text) {
  const decipher = crypto.createDecipheriv(algorithm, key, iv);
  var decripted =
    decipher.update(text, "base64", "utf8") + decipher.final("utf8");
  decripted = decripted;
  return decripted;
}
const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
  header: {
    minHeight: "150px",
    width: "100%",
    padding: "10px",
    marginBottom: "30px",
  },
  headertitle: {
    marginLeft: "10px",
  },
  table: {
    marginTop: "20px",
  },
  formControl: {
    minWidth: 120,
    marginBottom: "20px",
  },
  searchButton: {
    marginTop: "10px",
  },
};

const useStyles = makeStyles(styles);

const ArchiveBooks = (props) => {
  const classes = useStyles();
  const [arr, setArr] = React.useState([]);
  const [index, setIndex] = React.useState(-1);
  const [disabled, setNext] = React.useState(true);
  const [prevItems, setPrev] = React.useState([]);
  const [flag, setFlag] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [page, setPage] = React.useState(-1);
  const [loader, setLoader] = React.useState(null);
  const [book_name, setBookName] = React.useState(null);
  const [book_password, setBookPassword] = React.useState("");
  const [show, setShow] = React.useState(false);
  const [modalIsOpenReasonReject,setmodalIsOpenReasonReject] = useState(false);
  const [reasonRejectValue,setReasonRejectValue]= useState('');
  const [rejectBookData,setRejectBookData] = useState(null)

  const [state, setState] = React.useState({
    columns: [
      { title: "Book", field: "book_name" },
      { title: "Category", field: "category" },
      { title: "Sub Category", field: "subcategory" },
      { title: "Uploaded by", field: "User" },
      { title: "Date", field: "date" },
    ],
  });

  useEffect(() => {
    console.log(props.auth.isAdmin);
    var items = {};
    props.getUserBooks(items);
    setLoader(<CircularProgress color="secondary" />);
    setFlag(true);
  }, [props.auth]);

  //Function to listen to new paginated data
  useEffect(() => {
    console.log(props);
    if (flag) {
      //Push the next key in array
      setIndex(index + 1);
      setArr([...arr, props.books.Key]);
      prevItems.push.apply(prevItems, props.books.Books);
      setLoader(null);
      props.books.Books.map((data) => {
        data.date = DateConverter(data['ugc-timestamp']);
      });
      setData(prevItems);
    }
  }, [props.books]);

  // Load more Button to store previous state data and query for next paginated data
  const loadmore = (page) => {
    console.log(`page = ${page}`);
    console.log(`index = ${index}`);
    if (page > index && arr[index]) {
      setLoader(<CircularProgress color="secondary" />);
      var lastIndexKey = arr[index];
      setPrev(data);
      // Pass evaluated key and state contained dates
      props.getUserBooks(lastIndexKey);
    }
  };

  // Logic to disable load more button when no key is recieved
  useEffect(() => {
    if (props.books.Key) {
      setNext(false);
    } else {
      setNext(true);
    }
  }, [props.books.Key]);

  //Reset to clear states when new search is made
  const reset = () => {
    setData([]);
    //Reset the array
    setArr([]);
    //reset the previous date
    setPrev([]);
    setIndex(-1);
  };

  const RemoveArchive = (evt, data) => {
    setReasonRejectValue("")
    setmodalIsOpenReasonReject(true)
    setRejectBookData(data)
  };

  const switchArchive = ()=>{
    setmodalIsOpenReasonReject(false)
    setLoader(<CircularProgress color="secondary" />);
    axios
      .put(`/api/archiveSwitch`, { data:rejectBookData,bookStatusMessage:reasonRejectValue })
      .then((res) => {
        var key = {};
        reset();
        props.getUserBooks(key);
        setRejectBookData(null)
        setReasonRejectValue("")
      })
      .catch((err) => {
        setLoader(null);
        console.log(err);
        setRejectBookData(null)
        setReasonRejectValue("")
      });
  }

  const showPassword = (evt, data) => {
    setShow(true);
    setBookName(data.book_name);
    if (props.auth.isAdmin == true) {
      if (data.password == undefined) {
        setBookPassword("No Password");
      } else {
        setBookPassword(decrypt(data.password));
      }
    } else {
      setBookPassword("Not Authenticated");
    }
  };

  //Edit Book Page Link
  const editBook = (event, rowData) => {
    const link = "/admin/ViewBook/Book/" + rowData.id;
    props.history.push(link);
  };

  const reviewBook = (event, rowData) => {
    const win = window.open("/admin/ViewBook/Book/" + rowData.id, "_blank");
    win.focus();
  };

  const deleteBook = (event, rowData) => {
    setLoader(<CircularProgress color="secondary" />);
    axios
      .delete(`/api/deleteBook/${rowData.id}/${rowData.book_name}/Book`)
      .then((res) => {
        var key = {};
        reset();
        props.getUserBooks(key);
        setLoader(null);
      })
      .catch((err) => {
        console.log(err);
        alert("Error occured while deleting this book");
        setLoader(null);
      });
  };

  const getActions = () => {
    if (props.auth.isAdmin) {
      return [
        {
          icon: () => <Tooltip title="Edit Book" placement="bottom"><EditIcon/></Tooltip>,
          onClick: editBook,
        },
        {
          icon: () => <Tooltip title="Delete Book" placement="bottom"><DeleteIcon/></Tooltip>,
          onClick: deleteBook,
        },
        {
          icon: () =><Tooltip title="Reject/Archive Book" placement="bottom"><RemoveCircleIcon /></Tooltip>,
          onClick: RemoveArchive,
        },
        {
          icon: () => <Tooltip title="View Book Password" placement="bottom"><Eye/></Tooltip>,
          onClick: showPassword,
        },
        {
          icon: () => <Tooltip title="View Book" placement="bottom"><BookReview/></Tooltip>,
          onClick: reviewBook,
        },
      ];
    } else {
      return [
        {
          icon: () => <Tooltip title="Edit Book" placement="bottom"><EditIcon/></Tooltip>,
          onClick: editBook,
        },
        {
          icon: () => <Tooltip title="Delete Book" placement="bottom"><DeleteIcon/></Tooltip>,
          onClick: deleteBook,
        },
        {
          icon: () =><Tooltip title="Reject/Archive Book" placement="bottom"><RemoveCircleIcon /></Tooltip>,
          onClick: RemoveArchive,
        },
        {
          icon: () => <Tooltip title="View Book" placement="bottom"><BookReview/></Tooltip>,
          onClick: reviewBook,
        },
      ];
    }
  };

  return (
    <div>
      {loader}
      <MaterialTable
        title="User Book List"
        className={classes.table}
        columns={state.columns}
        data={data.map((x) => Object.assign({}, x))}
        options={{
          pageSize: 10,
        }}
        actions={getActions()}
        icons={
          ({ LastPage: () => <div /> },
          {
            FirstPage: () => <div />,
          })
        }
        onChangePage={(page) => {
          console.log(page);
          setPage(page);
          loadmore(page);
        }}
        components={{
          Pagination: (props) => (
            <TablePagination
              {...props}
              rowsPerPage={10}
              rowsPerPageOptions={[10]}
            />
          ),
        }}
      />
      <Modal
        show={show}
        onHide={() => setShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Password of {book_name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{book_password}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setShow(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
      {loader}
      <Modal
        backdrop="static"
        keyboard={false}
        show={modalIsOpenReasonReject}
        onHide={()=>{
          setReasonRejectValue("")
          setmodalIsOpenReasonReject(false)
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Please Specify a reason to Reject/Archive this book</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div class="input-group input-group-sm mb-3">
            <div class="input-group-prepend"></div>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <label>Enter Reason</label>
                
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <input
                  type="text"
                  class="form-control"
                  value={reasonRejectValue}
                  onChange={(e)=>setReasonRejectValue(e.target.value)}
                />
              </GridItem>
            </GridContainer>
          </div>
          <p id="lead" style={{ width: "100%" }}>
            <button
              class="btn btn-danger btn-sm"
              id="confirm"
              onClick={() => switchArchive()}
              href="#"
              role="button"
              style={{ width: "100%" }}
            >
              REJECT
            </button>
          </p>
        </Modal.Body>
      </Modal>
    </div>
  );
};
ArchiveBooks.propTypes = {
  getUserBooks: propTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
  books: state.books,
});

export default connect(
  mapStateToProps,
  { getUserBooks }
)(ArchiveBooks);
